module.exports = __webpack_public_path__ + "media/images/icons/material/visible-508b306c60f1691bb00fc42dc84b3db7.svg";